import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter } from '../../global/commonStyle';

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

interface TooltipContentProps {
  placement?: string;
  arrowLeft: string;
  arrowTop: string;
  backgroundColor: string;
  maxWidth: string | number;
  isInModal?: boolean;
  isShortCutKey?: boolean;
}

export const TooltipContent = styled.div<TooltipContentProps>`
  position: fixed;
  z-index: var(--z-index-modal);
  ${Typography.body_sm}
  background-color: ${(props) => props.backgroundColor};
  color: var(--text-white);
  padding: ${({ isShortCutKey }) =>
    isShortCutKey ? 'var(--space-4) var(--space-4) var(--space-4) var(--space-8)' : 'var(--space-4) var(--space-8)'};
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-tooltip-secondary);
  max-width: ${(props) => props.maxWidth || '100%'};
  width: 100%;
  ${({ isShortCutKey }) =>
    isShortCutKey &&
    css`
      ${AlignCenter}
      gap: var(--space-6);
    `}

  ${({ isInModal }) =>
    isInModal &&
    css`
      word-wrap: break-word;
    `}
    /* 
    * Tooltip arrow styles - currently disabled
    * This code creates CSS triangles for tooltip arrows using ::before and ::after pseudo-elements
    * The arrows are positioned based on placement prop and use border colors to create triangle shapes
    * Uncomment and adjust positioning as needed if arrow functionality is required
    */
  /* 
  &::before,
  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
    left: ${(props) => props.arrowLeft};
    top: ${(props) => props.arrowTop};
    transform: translateX(-61%);
    overflow: hidden;
    z-index: var(--z-index-toast);
  } */

  /* &::before {
    border: 6px solid transparent;
    z-index: var(--z-index-base);
    ${({ placement, backgroundColor }) => {
    switch (placement) {
      case 'bottom':
      case 'bottomLeft':
      case 'bottomRight':
        return css`
          border-bottom-color: ${backgroundColor};
          top: -12px;
          z-index: var(--z-index-toast);
        `;
      case 'top':
      case 'topLeft':
      case 'topRight':
        return css`
          border-top-color: ${backgroundColor};
          bottom: -12px;
          z-index: var(--z-index-toast);
        `;
      case 'left':
        return css`
          border-left-color: ${backgroundColor};
          right: -12px;
          top: 50%;
          z-index: var(--z-index-toast);
          transform: translateY(-50%);
        `;
      case 'right':
        return css`
          border-right-color: ${backgroundColor};
          left: -12px;
          top: 50%;
          z-index: var(--z-index-toast);
          transform: translateY(-50%);
        `;
      default:
        return '';
    }
  }}
  } */

  /* &::after {
    border: 5px solid transparent;
    z-index: 2;
    ${({ placement, backgroundColor }) => {
    switch (placement) {
      case 'bottom':
      case 'bottomLeft':
      case 'bottomRight':
        return css`
          border-bottom-color: ${backgroundColor};
          top: -11px;
        `;
      case 'top':
      case 'topLeft':
      case 'topRight':
        return css`
          border-top-color: ${backgroundColor};
          bottom: -11px;
        `;
      case 'left':
        return css`
          border-left-color: ${backgroundColor};
          right: -11px;
          top: 50%;
          transform: translateY(-50%);
        `;
      case 'right':
        return css`
          border-right-color: ${backgroundColor};
          left: -11px;
          top: 50%;
          transform: translateY(-50%);
        `;
      default:
        return '';
    }
  }}
  } */
  ${mobile_xl(css<TooltipContentProps>`
    max-width: ${(props) => props.maxWidth || 'calc(100% - 52px)'};
  `)}
`;

export const ShortCutKey = styled.div`
  border-radius: var(--border-radius-4);
  padding-inline: var(--space-4);
  background-color: var(--neutral-tooltip-secondary);
  color: var(--text-tooltip-secondary);
`;
